import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, Container, Typography } from '@mui/material';
import { NewPasswordRequired } from '../../components/NewPasswordRequired';
import { useAuth } from "../../contexts/AuthContext";

export const NewPasswordPage: React.FC = () => {
  const { confirmNewPassword, isLoading, error, clearError, tempUsername, isAuthenticated, requiresNewPassword } = useAuth();


  // If user is authenticated (password change successful), redirect to main app
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // If user doesn't need a new password anymore (but not authenticated), redirect to login
  if (!requiresNewPassword) {
    return <Navigate to="/login" replace />;
  }

  return (
    <Box minHeight="100vh" bgcolor="background.default" py={4}>
      <Container maxWidth="lg">
        <Box textAlign="center" mb={4}>
          <Typography variant="h3" component="h1" color="text.primary" gutterBottom>
            Tax Assist by Harness
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            Please set your new password
          </Typography>
        </Box>
        <NewPasswordRequired 
          onConfirmPassword={confirmNewPassword}
          isLoading={isLoading}
          error={error}
          onClearError={clearError}
          username={tempUsername || ''}
        />
      </Container>
    </Box>
  );
};